<template>
  <div class="IndexShow" :style="{ background: BackgroundsColors,height }">
    <!-- 模型层界面 -->
    <ModelRendering  @modelClick="handleModelClick" v-if="ModelRenderings"></ModelRendering>
    <!-- 菜单栏 -->
    <transition
      enter-active-class="animate__animated animate__fadeInUp"
      leave-active-class="animate__animated animate__fadeOutDown">
        <MenuInterface
          class="MenuInterface"
          v-show="MenuBarHideShow"
          :meshs="modelmesh">
        </MenuInterface>
    </transition>
    <!-- 底部总导航栏 -->
    <GeneralToolbar
      class="GeneralToolbar"
    ></GeneralToolbar>
    <!-- 用户 -->
    <UserInformation></UserInformation>
    <!-- 测量工具 -->
    <keep-alive>
      <Measure class="Measure" v-if="Measures" ></Measure>
    </keep-alive>
  </div>
</template>
<script>
// 底部总导航栏
import GeneralToolbar from "@/views/GeneralToolbar/GeneralToolbar.vue";
// 菜单栏
import MenuInterface from "@/views/MenuInterface/MenuInterface.vue";
// 用户
import UserInformation from "@/views/UserInformation/UserInformation.vue";
// 模型图
import ModelRendering from "@/views/ModelRendering/ModelRendering.vue";
// 测量工具
import Measure from "@/views/MeasuresCount/Measures.vue";
import { mapState } from "vuex";
import { mapMutations } from "vuex";

export default {
  components: {
    GeneralToolbar,
    MenuInterface,
    UserInformation,
    ModelRendering,
    Measure,
  },
  data() {
    return {
      height:document.documentElement.clientHeight+"px",
      MenuBarHideShow: true,
      targetDivIds: '',
      BackgroundsColors:
       "#ffffff",
        previousDiv:null,
        modelmesh:null,
        // 测量工具是否加载
        Measures:false,
        // 颜色选择
        FatherColorSelector:false,
        ModelRenderings:true
    };
  },

  methods: {
    ...mapMutations(["setActiveMeshId","setTargetDivHtml","setActiveTabName","setActiveModelName"]),
    // // 控制菜单栏的显示与隐藏
    // MenuBarHide(val) {
    //   this.MenuBarHideShow = val;
    // },
    handleModelClick(MeshChild) {
      this.$nextTick(() => {
     const   id=this.$store.state.listColor
     id.forEach(item=>{
    if(  document.getElementById( item.modelId).classList[1]) {
      document.getElementById( item.modelId).classList.remove('active')
    }
     })
       this.modelmesh= MeshChild
       this.setActiveMeshId(MeshChild.model_id)
       this.setActiveModelName(MeshChild.name)
        const targetDiv = document.getElementById(MeshChild.model_id);
         const parentNodes=document.getElementById(targetDiv?.parentNode?.parentNode.id).id
        this.setActiveTabName(parentNodes)
        if( targetDiv?.classList[1]){
          return
        }
          targetDiv.classList.add('active');
         this.setTargetDivHtml(targetDiv.innerHTML)
          if (this.previousDiv) {
      this.previousDiv.classList.remove('active');
    }
    if(targetDiv==this.previousDiv){
      targetDiv.classList.add('active');

    }
        // 点击模型后，给跳转目标添加激活样式
        this.previousDiv=targetDiv
        if (targetDiv) {
          targetDiv.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  },
  mounted(){
    this.height=document.documentElement.clientHeight
  },

  watch: {
    backgroundColor(newModelDisplayAndHiding, oldModelDisplayAndHiding) {
      this.BackgroundsColors = newModelDisplayAndHiding;
    },
    targetDivHtml(newtargetDIv, oldtargetDIv) {
         
         this.targetDIVs =( newtargetDIV)
         if(newtargetDIV){
          this.FatherColorSelector=true
         }
       },
    measurementVisible(news,old){
      this.Measures=news
    },
    menuVisible(news,old){
      this.MenuBarHideShow=news
    }
  },
  computed: {
    ...mapState(["backgroundColor","measurementVisible","menuVisible"]),
       // ...mapState(["selectedChange"]),
  },
};
</script>
<style  scoped lang="scss">
.IndexShow {
    width: 100vw;
  
    position: fixed;
    > .GeneralToolbar {
      position: absolute;
      top: 0;
    }
    > .MenuInterface {
      position: absolute;
      bottom: 10px;
      left: 10px;
  
    }
  }
</style>
